import React, { useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import ProgressMessage from './ProgressMessage';
import '../css/Step1.css';


const CategoryRegister = () => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [error, setError] = useState(null);
  const [statusMessage, setStatusMessage] = useState('대기중...');
  const [isImporting, setIsImporting] = useState(false);
  const [isFinished , setIsFinished] = useState(false);
  const [categoryFileAttached, setCategoryFileAttached] = useState(false);
  const [animatedText, setAnimatedText] = useState('');

  const fullText = 'Insert Category Excel to DB';
  
  useEffect(() => {
    if (isImporting) {
      let currentIndex = 0;

      // Timer to animate text
      const timer = setInterval(() => {
        setAnimatedText(fullText.slice(0, currentIndex + 1));
        currentIndex++;

        if (currentIndex === fullText.length) {
          currentIndex = 0; // Restart animation
        }
      }, 150); // Adjust speed here

      return () => clearInterval(timer); // Clean up on unmount or stop
    } else {
      setAnimatedText(fullText); // Reset text when not extracting
    }
  }, [isImporting]);

  const handleFileChange = (event, fileType) => {
    const selectedFile = event.target.files[0];

    // 
    // 추후에 정확한 상품카테고리 엑셀인지도 검사하는 코드 추가할 예정 
    // 아마도 컬럼명 이런거 대조할듯함 
    if (selectedFile && (selectedFile.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || selectedFile.type === "application/vnd.ms-excel")) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
      setError("");
      setStatusMessage('파일이 선택되었습니다. \n Import를 실행해주십시오.');

      if(fileType === 'category') {
        setCategoryFileAttached(true);
      } 
    } else {
      setFile(null);
      setFileName(null);
      setError("엑셀 파일만 첨부할 수 있습니다.");

      if (fileType === 'category') {
        setCategoryFileAttached(false);
      }
    }
  };

  const handleImport = () => {
    if (!file) return;
    setError("");
    setIsImporting(true);
    setStatusMessage('업로드 중...');
    const formData = new FormData();
    formData.append('file', file);

    axios.post('http://localhost:5000/uploads-category/upload-category-excel', formData)
    .then(response => {
      console.log('File uploaded successfully:', response.data);
      setStatusMessage('파일 업로드 완료. Excel 파싱...');
      insertDataIntoDB(response.data.file.path); // 파일 경로를 통해 DB 삽입 작업 요청
    })
    .catch(error => {
      console.error('Error uploading file:', error);
      setError('파일 업로드 중 오류가 발생했습니다.');
      setStatusMessage('업로드 실패.');
      setIsImporting(false);
    });
  };

  const insertDataIntoDB = (categoryPath) => {  
    console.log(`filePath check : ${categoryPath}`);
    axios.post('http://localhost:5000/uploads-category/insert-category-excel', {categoryPath})
      .then(response => {
        setStatusMessage("데이터 입력 완료. 다음 단계로 넘어갑니다."); // 서버로부터 받은 상태 메시지 업데이트
        setIsImporting(false);
        setIsFinished(true);
      })
      .catch(error => {
        console.error('Error inserting data into DB:', error);
        setError('DB 삽입 중 오류가 발생했습니다.');
        setStatusMessage('DB 삽입 실패.');
        setIsImporting(false);
        setIsFinished(false);
      });
  };
  const handleCategoryCallAPI = () => {
    console.log(`Category API IS CALLED`);
    setIsImporting(true);
    setIsFinished(false);
    axios.post('http://localhost:5000/uploads-category/call-category-api')
      .then(response => {
        
      })
  }
  return (
    <motion.div
      className="step-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h2>Category Excel Register</h2>
      <p className={`animated-text ${isImporting ? 'importing' : ''}`}>
        {animatedText}
      </p>
      <div className="category-upload-container">
        
        <input
          type="file"
          id="category-file-upload"
          onChange={(e) => handleFileChange(e, 'category')}
          accept=".xlsx,.xls"
          hidden
        />
        <label htmlFor="category-file-upload" className="file-upload-button">카테고리 엑셀 선택</label>
        <span className="file-upload-label">
          {categoryFileAttached ? `${fileName} 파일이 첨부되었습니다.` : '카테고리 엑셀 파일을 첨부하세요.'}
        </span>
        {error && <span className="error-message">{error}</span>}
      </div>
      <div className="category-upload-container">
        <button onClick={handleCategoryCallAPI} className="import-button" disabled={isImporting }>
          API 호출
        </button>
        {error && <span className="error-message">{error}</span>}
      </div>



      <div className="import-container">
        <button onClick={handleImport} className="import-button" disabled={isImporting ||  !categoryFileAttached}>
          Import
        </button>
        <ProgressMessage message={statusMessage} />
        {isFinished && !isImporting && <Link to="/category-db-conversion" className="next-button">Next</Link>}
      </div>
    </motion.div>
  );
};

export default CategoryRegister;
